"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "treviglio": {
    "502403bc": [{
      "hkey": "ccd2ae19",
      "slug": "cascina-pezzoli",
      "name": "Cascina Pezzoli",
      "primary": true,
      "skipSearch": false
    }],
    "pezzoli": [{
      "hkey": "ccd2ae19",
      "slug": "cascina-pezzoli",
      "name": "Cascina Pezzoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;